import { roundedNumericFormatter } from "../../../../utils/RoundedNumberFormat";
import { roundWithPrecision } from "../../../../utils/roundWithPrecision";

function getDiff({
  originalValue,
  targetValue,
  precision = 2
}: {
  originalValue: number;
  targetValue: number;
  precision?: number;
}) {
  const roundedOriginalValue = roundWithPrecision(originalValue, precision);
  const roundedTargetValue = roundWithPrecision(targetValue, precision);

  const diff = roundWithPrecision(
    roundedOriginalValue - roundedTargetValue,
    precision
  );
  const diffPercent =
    roundedOriginalValue === 0
      ? 0
      : roundWithPrecision((diff / roundedOriginalValue) * 100, precision);

  const tooltipLabel = `Differenz: ${roundedNumericFormatter(diff)} (${roundedNumericFormatter(diffPercent)}%)`;
  return { diff, diffPercent, tooltipLabel };
}

export { getDiff };
